// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 245) return "static/chunks/245-82a19e44f0f42b52.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"553f23a04597778a","205":"67e56ec58883c7b0","319":"0cbc2894a3f1b950","340":"e647563dfb856987","367":"79d6a4545097bf64","639":"1a7fe1eeeb9595ae","748":"11aa5fccf2a8b256"}[chunkId] + ".js";
};